"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var overview_field_type_1 = require("../model/overview-field-type");
var operators_1 = require("rxjs/operators");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var custom_aggregate_filtering_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-filtering-provider.service");
var overview_helper_service_1 = require("../service/overview-helper.service");
var custom_aggregate_functions_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-functions-provider.service");
var overview_custom_calculation_fields_service_1 = require("../../../../shared/services/api/summary-pages/custom-calculation/overview-custom-calculation-fields.service");
var overview_custom_component_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-component/overview-custom-component-provider.service");
var overview_card_type_1 = require("../model/overview-card-type");
/**
 * Deserialize row of overview fields for overview-item.
 */
var OverviewDeserializeFieldsPipe = /** @class */ (function () {
    function OverviewDeserializeFieldsPipe(classifierService, overviewHelperService, customAggregateFilteringProviderService, customAggregateFunctionsProviderService, overviewCustomComponentProviderService, overviewCustomCalculationFieldsService) {
        this.classifierService = classifierService;
        this.overviewHelperService = overviewHelperService;
        this.customAggregateFilteringProviderService = customAggregateFilteringProviderService;
        this.customAggregateFunctionsProviderService = customAggregateFunctionsProviderService;
        this.overviewCustomComponentProviderService = overviewCustomComponentProviderService;
        this.overviewCustomCalculationFieldsService = overviewCustomCalculationFieldsService;
    }
    OverviewDeserializeFieldsPipe.prototype.transform = function (overviewFields, category, rootCategoryName, rootEntity, childEntities, cardType) {
        var _this = this;
        var overviewFields$ = [];
        overviewFields.forEach(function (overviewField) {
            return overviewField.fieldName && overviewFields$.push(_this.deserializeSingleField(overviewField, category, rootCategoryName, rootEntity, childEntities, cardType).pipe(operators_1.map(function (result) { return overviewField.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.COMPONENT ? result
                : result && result; })));
        });
        if (!overviewFields$.length) {
            return Observable_1.Observable.of(null);
        }
        return Observable_1.Observable.zip.apply(Observable_1.Observable, overviewFields$).pipe(operators_1.map(function (customValues) {
            var result = [];
            customValues.forEach(function (value) {
                return value && result.push.apply(result, value.filter(function (item) { return !item.hideValue; }));
            });
            return result.length ? result : null;
        }));
    };
    OverviewDeserializeFieldsPipe.prototype.deserializeSingleField = function (overviewField, category, rootCategoryName, rootEntity, childEntities, cardType) {
        if (overviewField.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.COMPONENT) {
            return this.getComponentFieldProperties(overviewField, category, rootCategoryName, rootEntity, childEntities, cardType).pipe(operators_1.map(function (cmp) { return [cmp]; }));
        }
        if (overviewField.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE) {
            return this.getAggregateFieldResults(overviewField, category, rootCategoryName, rootEntity, childEntities, cardType);
        }
        if (overviewField.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.CALCULATION) {
            return this.calculateOverviewCalculationResults(overviewField, category, rootCategoryName, rootEntity, childEntities, cardType);
        }
        return this.getEntityField(overviewField, category, rootEntity, childEntities, cardType).pipe(operators_1.map(function (value) { return [value]; }));
    };
    OverviewDeserializeFieldsPipe.prototype.getComponentFieldProperties = function (overviewField, category, rootCategoryName, rootEntity, childEntities, cardType) {
        return this.overviewCustomComponentProviderService.getCustomComponents(category, rootCategoryName, cardType).pipe(operators_1.map(function (components) {
            var selectedComponent = components.find(function (cmp) { return cmp.componentSelector === overviewField.fieldName; });
            selectedComponent.componentInputs = __assign({ entity: rootEntity, entities: childEntities, category: category }, selectedComponent.componentInputs);
            return components.find(function (cmp) { return cmp.componentSelector === overviewField.fieldName; });
        }));
    };
    OverviewDeserializeFieldsPipe.prototype.getEntityField = function (overviewField, category, rootEntity, childEntities, cardType) {
        if (cardType === overview_card_type_1.OverviewCardType.MAIN_CARD) {
            return this.overviewHelperService.deserializeEntityForCard(overviewField, rootEntity, category);
        }
        else if (cardType === overview_card_type_1.OverviewCardType.SINGLE_ENTITY_CARD) {
            return this.overviewHelperService.deserializeEntityForCard(overviewField, childEntities && childEntities.length ? childEntities[0] : null, category);
        }
        return Observable_1.Observable.of({ title: null, value: null });
    };
    OverviewDeserializeFieldsPipe.prototype.getAggregateFieldResults = function (overviewField, category, rootCategoryName, rootEntity, childEntities, cardType) {
        var _this = this;
        // load classifier values to group by
        var loadGroupingClassifiers$ = overviewField.aggregateConfig.groupingField ?
            (overviewField.aggregateConfig.groupingFieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE ?
                this.overviewHelperService.getWFStates(category) :
                this.overviewHelperService.getClassifierViews(overviewField.aggregateConfig.groupingFieldCompoundCategory, null))
            : Observable_1.Observable.of(null);
        return loadGroupingClassifiers$.pipe(operators_1.switchMap(function (items) {
            var groupResults$ = [];
            if (items && items.length) {
                var itemGroups_1 = {};
                items = items.sort(function (classifier1, classifier2) { return classifier1.id - classifier2.id; });
                items.forEach(function (item) { return itemGroups_1[item.id] = []; });
                var sourceItems_1 = [];
                if (cardType === overview_card_type_1.OverviewCardType.GROUP_CARD) {
                    sourceItems_1 = childEntities || [];
                }
                else if (cardType === overview_card_type_1.OverviewCardType.SINGLE_ENTITY_CARD) {
                    sourceItems_1 = childEntities && childEntities.length &&
                        childEntities[0].getProperty(overviewField.aggregateConfig.sourceField).value || [];
                }
                else {
                    sourceItems_1 = rootEntity && rootEntity.getProperty(overviewField.aggregateConfig.sourceField).value || [];
                }
                sourceItems_1.forEach(function (sourceItem) {
                    var sourceItemValue = sourceItem.getProperty(overviewField.aggregateConfig.groupingField).value;
                    if (sourceItemValue) {
                        var valueId = overviewField.aggregateConfig.groupingFieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY ?
                            sourceItemValue.getInstanceId()
                            : sourceItemValue.getId();
                        itemGroups_1[valueId].push(sourceItem);
                    }
                    else {
                        if (itemGroups_1[0]) {
                            itemGroups_1[0].push(sourceItem);
                        }
                        else {
                            itemGroups_1[0] = [sourceItem];
                        }
                    }
                });
                Object.keys(itemGroups_1).forEach(function (groupKey) {
                    var aggregateFilter$ = _this.customAggregateFilteringProviderService && overviewField.aggregateConfig.customFilter ?
                        _this.customAggregateFilteringProviderService.filter(overviewField.aggregateConfig.customFilter, category, rootCategoryName, sourceItems_1, overviewField.aggregateConfig)
                        : Observable_1.Observable.of(itemGroups_1[groupKey]);
                    groupResults$.push(aggregateFilter$
                        .pipe(operators_1.switchMap(function (result) {
                        return _this.customAggregateFunctionsProviderService
                            .calculate(overviewField.fieldName, category, rootCategoryName, result, overviewField.aggregateConfig, items.find(function (value) { return value.id === Number(groupKey); }));
                    })));
                });
            }
            else {
                // when we need to load all
                var entityToLoadFrom = cardType === overview_card_type_1.OverviewCardType.MAIN_CARD ?
                    (rootEntity && rootEntity.getProperty(overviewField.aggregateConfig.sourceField).value)
                    : (cardType === overview_card_type_1.OverviewCardType.SINGLE_ENTITY_CARD ?
                        (childEntities && childEntities.length
                            && childEntities[0].getProperty(overviewField.aggregateConfig.sourceField).value)
                        : childEntities);
                var aggregateFilter$ = _this.customAggregateFilteringProviderService && overviewField.aggregateConfig.customFilter ?
                    _this.customAggregateFilteringProviderService.filter(overviewField.aggregateConfig.customFilter, category, rootCategoryName, entityToLoadFrom, overviewField.aggregateConfig)
                    : Observable_1.Observable.of(entityToLoadFrom);
                groupResults$.push(aggregateFilter$
                    .pipe(operators_1.switchMap(function (result) {
                    return _this.customAggregateFunctionsProviderService
                        .calculate(overviewField.fieldName, category, rootCategoryName, result, overviewField.aggregateConfig, null);
                })));
            }
            return Observable_1.Observable.zip.apply(Observable_1.Observable, groupResults$);
        }));
    };
    OverviewDeserializeFieldsPipe.prototype.calculateOverviewCalculationResults = function (overviewField, category, rootCategoryName, rootEntity, childEntities, cardType) {
        return this.overviewCustomCalculationFieldsService ?
            this.overviewCustomCalculationFieldsService.calculate(overviewField.fieldName, category, rootCategoryName, cardType, rootEntity, childEntities)
            : Observable_1.Observable.of([]);
    };
    OverviewDeserializeFieldsPipe = __decorate([
        core_1.Pipe({
            name: 'overviewDeserializeFields',
            pure: true
        }),
        __param(2, core_1.Optional()),
        __param(3, core_1.Optional()),
        __param(4, core_1.Optional()),
        __param(5, core_1.Optional()),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
            overview_helper_service_1.OverviewHelperService,
            custom_aggregate_filtering_provider_service_1.CustomAggregateFilteringProviderService,
            custom_aggregate_functions_provider_service_1.CustomAggregateFunctionsProviderService,
            overview_custom_component_provider_service_1.OverviewCustomComponentProviderService,
            overview_custom_calculation_fields_service_1.OverviewCustomCalculationFieldsService])
    ], OverviewDeserializeFieldsPipe);
    return OverviewDeserializeFieldsPipe;
}());
exports.OverviewDeserializeFieldsPipe = OverviewDeserializeFieldsPipe;
//# sourceMappingURL=overview-deserialize-fields.pipe.js.map